export const VEHICLE_USER = 'VEHICLE_USER';
export const PREFERRED_LOCATIONS = 'PREFERRED_LOCATIONS';
